/**
 * abilityVfxLux — Lux Q/W/E/R light silhouettes (SPY-212).
 */

function mat(THREE, color, opacity = 0.9) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: opacity < 1,
    opacity,
    side: THREE.DoubleSide
  });
}

function addTriplet(THREE, group, s, primary, accent) {
  const core = new THREE.Mesh(new THREE.SphereGeometry(0.22 * s, 10, 10), primary);
  core.position.y = 0.5 * s;
  group.add(core);
  const beam = new THREE.Mesh(new THREE.CylinderGeometry(0.06 * s, 0.08 * s, 1.2 * s, 8), accent);
  beam.position.y = 0.9 * s;
  group.add(beam);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.25 * s, 0.45 * s, 16).rotateX(-Math.PI / 2),
    primary
  );
  ring.position.y = 0.08;
  group.add(ring);
}

export function buildLightBinding(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1);
  addTriplet(THREE, group, s, mat(THREE, spec.color || 0x38bdf8), mat(THREE, 0xe0f2fe));
  group.userData = { shape: 'light_binding' };
  return group;
}

export function buildPrismaticBarrier(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.6 * (spec.scale || 1.3);
  const blue = mat(THREE, spec.color || 0x7dd3fc, 0.85);
  const soft = mat(THREE, 0xbae6fd, 0.8);
  const dome = new THREE.Mesh(new THREE.SphereGeometry(0.55 * s, 12, 10), blue);
  dome.position.y = 0.55 * s;
  group.add(dome);
  const band = new THREE.Mesh(
    new THREE.TorusGeometry(0.5 * s, 0.05 * s, 8, 16),
    soft
  );
  band.rotation.x = Math.PI / 2;
  band.position.y = 0.55 * s;
  group.add(band);
  const spark = new THREE.Mesh(new THREE.SphereGeometry(0.12 * s, 8, 8), soft);
  spark.position.set(0.4 * s, 0.9 * s, 0);
  group.add(spark);
  group.userData = { shape: 'prismatic_barrier' };
  return group;
}

export function buildLucentSingularity(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.7 * (spec.scale || 1.6);
  const cyan = mat(THREE, spec.color || 0x22d3ee, 0.88);
  const glow = mat(THREE, 0xa5f3fc, 0.75);
  const orb = new THREE.Mesh(new THREE.SphereGeometry(0.35 * s, 12, 12), cyan);
  orb.position.y = 0.4 * s;
  group.add(orb);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.4 * s, 0.85 * s, 24).rotateX(-Math.PI / 2),
    glow
  );
  ring.position.y = 0.05;
  group.add(ring);
  const spike = new THREE.Mesh(new THREE.ConeGeometry(0.1 * s, 0.4 * s, 6), cyan);
  spike.position.y = 0.85 * s;
  group.add(spike);
  group.userData = { shape: 'lucent_singularity' };
  return group;
}

export function buildFinalSpark(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.75 * (spec.scale || 1.8);
  const gold = mat(THREE, spec.color || 0xfde047, 0.92);
  const white = mat(THREE, 0xfffbeb, 0.9);
  const beam = new THREE.Mesh(new THREE.BoxGeometry(0.2 * s, 0.15 * s, 2.4 * s), gold);
  beam.position.set(0, 0.5 * s, 0);
  group.add(beam);
  const muzzle = new THREE.Mesh(new THREE.SphereGeometry(0.25 * s, 10, 10), white);
  muzzle.position.set(0, 0.5 * s, -1.1 * s);
  group.add(muzzle);
  const flash = new THREE.Mesh(
    new THREE.RingGeometry(0.2 * s, 0.55 * s, 16).rotateX(-Math.PI / 2),
    gold
  );
  flash.position.set(0, 0.08, 1.1 * s);
  group.add(flash);
  group.userData = { shape: 'final_spark' };
  return group;
}
